import { BaseAPIModel } from '@weezevent/weezjs-core';

export class Identity extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId }) {
        return `/target/organizations/${organizationId}/identities`;
    }
}
